import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import GlobalLayout from 'global/components/features/signinSignup/layout/SigninSignupLayout'
import Wrapper from 'global/components/features/signinSignup/layout/SigninSignupWrapper'
import Header from 'global/components/features/signinSignup/layout/SigninSignupHeader'
import Content from 'global/components/features/signinSignup/layout/SigninSignupContent'
import ContentColumn from 'global/components/features/signinSignup/layout/SigninSignupContentColumn'
import Connect from 'global/components/features/signinSignup/layout/SigninSignupConnect'
import { useFormatMessage } from 'global/lib/localization'

import Layout from 'fir/components/lib/layout/Layout'

export interface Props {
  error?: string | false
  children: any
}

interface SigninSignupLayoutFC<TProps> extends React.FC<TProps> {
  Wrapper: React.FC<any>
  Header: React.FC<any>
  Content: React.FC<any>
  ContentColumn: React.FC<any>
  Connect: React.FC<any>
}

const BASE_I18N_KEY = 'fir.app.signin_connect'

const SigninSignupLayout: SigninSignupLayoutFC<Props> = ({ error, children }) => {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)

  return useMemo(
    () => (
      <Layout pageTitle={formatMessage('page_title')}>
        <GlobalLayout error={error} isMaintenanceBannerEnabled>
          {children}
        </GlobalLayout>
      </Layout>
    ),
    [formatMessage, error, children]
  )
}

SigninSignupLayout.Wrapper = Wrapper
SigninSignupLayout.Header = Header
SigninSignupLayout.Content = Content
SigninSignupLayout.ContentColumn = ContentColumn
SigninSignupLayout.Connect = Connect

SigninSignupLayout.propTypes = {
  error: PropTypes.any,
  children: PropTypes.any.isRequired
}

SigninSignupLayout.defaultProps = {
  error: false
}

export default SigninSignupLayout
